import { createAction, props } from "@ngrx/store";

export const FETCH_APPOINTMENT_TYPE_LIST = createAction(
    'FETCHAPPOINTMENTTYPELIST',
    props<{ appointmentTypes: any }>()
);